import getStat, { getXlsx } from "../../http/statApi";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Tabs,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Chip,
    Box,
    Typography,
    IconButton,
    alpha,
    styled,
    useMediaQuery,
    useTheme
} from '@mui/material';
import { 
    Download, 
    Traffic, 
    Speed, 
    LocalParking, 
    DirectionsCar,
    Warning,
    StopCircle,
    TurnLeft,
    Today,
    DateRange,
    Close
} from '@mui/icons-material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import fileDownload from 'js-file-download';
import { useMap } from 'react-leaflet';

// Стилизованные компоненты таблицы (как в PautinaDialog)
const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
    backgroundColor: 'var(--background-paper)',
    border: '1px solid var(--border-default)',
    borderRadius: theme.breakpoints.down('md') ? '6px' : '8px',
    '& .MuiTable-root': {
        borderCollapse: 'collapse',
    },
}));

const StyledTableHead = styled(TableHead)(({ theme }) => ({
    '& .MuiTableCell-head': {
        backgroundColor: 'var(--table-header-bg)',
        color: 'var(--text-secondary)',
        fontWeight: 600,
        fontSize: theme.breakpoints.down('md') ? '9px' : '11px',
        padding: theme.breakpoints.down('md') ? '6px 8px' : '10px 12px',
        borderBottom: '1px solid var(--border-default)',
        borderRight: '1px solid var(--border-default)',
        whiteSpace: 'nowrap',
        position: 'sticky',
        top: 0,
        zIndex: 1,
        '&:last-child': {
            borderRight: 'none',
        },
    },
}));

const StyledTableRow = styled(TableRow)(() => ({
    transition: 'background-color 0.15s ease',
    backgroundColor: 'var(--table-row-bg)',
    '&:hover': {
        backgroundColor: 'var(--table-row-hover)',
    },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    fontSize: theme.breakpoints.down('md') ? '9px' : '11px',
    padding: theme.breakpoints.down('md') ? '6px 8px' : '10px 12px',
    color: 'var(--text-primary)',
    borderBottom: '1px solid var(--table-border)',
    borderRight: '1px solid var(--table-border)',
    '&:last-child': {
        borderRight: 'none',
    },
}));

const TotalTableRow = styled(TableRow)(({ theme }) => ({
    backgroundColor: 'var(--table-header-bg)',
    '& .MuiTableCell-root': {
        fontWeight: 600,
        fontSize: theme.breakpoints.down('md') ? '9px' : '11px',
        color: 'var(--text-primary)',
    },
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div role="tabpanel" hidden={value !== index} {...other}>
            {value === index && <Box sx={{ pt: { xs: 1, md: 2 } }}>{children}</Box>}
        </div>
    );
}

const ModalStat = props => {
    const map = useMap();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const isDarkMode = useSelector(state => state.settings.darkMode);
    const [interval, setInterval] = useState([dayjs().startOf('day'), dayjs()]);
    const [statisic, setStatisic] = useState([]);
    const [fixations, setFixations] = useState(0);
    const [violations, setViolations] = useState(0);
    const [tabValue, setTabValue] = useState(0);

    const primaryColor = isDarkMode ? '#58a6ff' : '#0969da';
    const successColor = isDarkMode ? '#3fb950' : '#2da44e';
    const errorColor = '#d63a23';

    const handleTabChange = (event, newValue) => setTabValue(newValue);

    const datePickerSx = {
        // Стили для стандартного TextField (MUI v5+)
        '& .MuiOutlinedInput-root': {
            backgroundColor: 'var(--background-paper)',
            borderRadius: { xs: '4px', md: '8px' },
            '& fieldset': { borderColor: 'var(--border-default)' },
            '&:hover fieldset': { borderColor: primaryColor },
            '&.Mui-focused fieldset': { borderColor: primaryColor }
        },
        // Стили для DatePicker компонентов (MuiPickersInputBase)
        '& .MuiPickersInputBase-root': {
            color: 'var(--text-primary)',
            fontSize: { xs: '11px', md: '12px' },
            backgroundColor: 'var(--background-paper)',
            borderRadius: { xs: '4px', md: '8px' },
            '& fieldset': { borderColor: 'var(--border-default)' },
            '&:hover fieldset': { borderColor: primaryColor },
            '&.Mui-focused fieldset': { borderColor: primaryColor }
        },
        '& .MuiPickersOutlinedInput-root': {
            backgroundColor: 'var(--background-paper)',
            borderRadius: { xs: '4px', md: '8px' },
            '& fieldset': { borderColor: 'var(--border-default)' },
            '&:hover fieldset': { borderColor: primaryColor },
            '&.Mui-focused fieldset': { borderColor: primaryColor }
        },
        // Label стили
        '& .MuiInputLabel-root': { 
            color: 'var(--text-muted)',
            fontSize: { xs: '10px', md: '11px' }
        },
        '& .MuiInputLabel-root.Mui-focused': { color: primaryColor },
        '& .MuiPickersInputBase-label': { 
            color: 'var(--text-muted)',
            fontSize: { xs: '10px', md: '11px' }
        },
        '& .MuiPickersInputBase-label.Mui-focused': { color: primaryColor },
        // Input стили
        '& .MuiOutlinedInput-input': { 
            color: 'var(--text-primary)',
            fontSize: { xs: '10px', md: '11px' },
            padding: { xs: '5px 8px', md: '6px 10px' }
        },
        '& .MuiPickersInputBase-input': { 
            color: 'var(--text-primary)',
            fontSize: { xs: '10px', md: '11px' },
            padding: { xs: '5px 8px', md: '6px 10px' }
        },
        // Иконка
        '& .MuiInputAdornment-root .MuiSvgIcon-root': { 
            color: 'var(--text-muted)',
            fontSize: { xs: '16px', md: '18px' }
        },
        '& .MuiPickersInputAdornment-root .MuiSvgIcon-root': { 
            color: 'var(--text-muted)',
            fontSize: { xs: '16px', md: '18px' }
        }
    };

    const datePickerPopperSx = {
        backgroundColor: 'var(--background-paper)',
        border: '1px solid var(--border-default)',
        borderRadius: { xs: '8px', md: '12px' },
        boxShadow: isDarkMode 
            ? '0 8px 24px rgba(0, 0, 0, 0.4)' 
            : '0 8px 24px rgba(0, 0, 0, 0.15)',
        '& .MuiPickersCalendarHeader-root': {
                padding: { xs: '8px 12px', md: '12px 16px' },
                '& .MuiPickersCalendarHeader-label': {
                    color: 'var(--text-primary)',
                    fontSize: { xs: '0.875rem', md: '1rem' },
                    fontWeight: 600
                },
                '& .MuiIconButton-root': {
                    color: 'var(--text-secondary)',
                    padding: { xs: '4px', md: '8px' },
                    '&:hover': {
                        backgroundColor: 'var(--hover-bg)'
                    },
                    '& .MuiSvgIcon-root': {
                        fontSize: { xs: '18px', md: '20px' }
                    }
                }
            },
            '& .MuiDayCalendar-weekContainer': {
                margin: { xs: '2px', md: '4px' }
            },
            '& .MuiPickersDay-root': {
                color: 'var(--text-primary)',
                fontSize: { xs: '0.75rem', md: '0.875rem' },
                width: { xs: '32px', md: '36px' },
                height: { xs: '32px', md: '36px' },
                borderRadius: { xs: '4px', md: '6px' },
                '&:hover': {
                    backgroundColor: 'var(--hover-bg)'
                },
                '&.Mui-selected': {
                    backgroundColor: primaryColor,
                    color: 'white',
                    fontWeight: 600,
                    '&:hover': {
                        backgroundColor: alpha(primaryColor, 0.8)
                    },
                    '&:focus': {
                        backgroundColor: primaryColor
                    }
                },
                '&.MuiPickersDay-today': {
                    border: `1px solid ${primaryColor}`,
                    fontWeight: 600
                }
            },
            '& .MuiPickersCalendarHeader-switchViewButton': {
                color: 'var(--text-secondary)',
                '&:hover': {
                    backgroundColor: 'var(--hover-bg)'
                }
            },
            '& .MuiPickersYear-yearButton': {
                color: 'var(--text-primary)',
                fontSize: { xs: '0.875rem', md: '1rem' },
                '&:hover': {
                    backgroundColor: 'var(--hover-bg)'
                },
                '&.Mui-selected': {
                    backgroundColor: primaryColor,
                    color: 'white',
                    '&:hover': {
                        backgroundColor: alpha(primaryColor, 0.8)
                    }
                }
            },
            '& .MuiPickersMonth-monthButton': {
                color: 'var(--text-primary)',
                fontSize: { xs: '0.875rem', md: '1rem' },
                '&:hover': {
                    backgroundColor: 'var(--hover-bg)'
                },
                '&.Mui-selected': {
                    backgroundColor: primaryColor,
                    color: 'white',
                    '&:hover': {
                        backgroundColor: alpha(primaryColor, 0.8)
                    }
                }
            }
    };

    const quickButtonSx = {
        borderColor: 'var(--border-default)',
        color: 'var(--text-secondary)',
        fontSize: { xs: '10px', md: '11px' },
        textTransform: 'none',
        borderRadius: { xs: '4px', md: '6px' },
        padding: { xs: '3px 8px', md: '4px 10px' },
        '&:hover': {
            borderColor: primaryColor,
            backgroundColor: alpha(primaryColor, 0.08)
        }
    };

    const toExcel = async () => {
        if (!interval) return;
        const response = await getXlsx(interval[0].toDate(), interval[1].toDate());
        fileDownload(response.data, `отчет ${interval[0].format('DD.MM.YYYY')} - ${interval[1].format('DD.MM.YYYY')}.xlsx`);
    };

    useEffect(() => {
        if (interval[0].isAfter(interval[1])) {
            setInterval([interval[1], interval[1]]);
        } else {
            getStat(interval[0].toDate(), interval[1].toDate()).then(data => {
                if (data) {
                    setStatisic(data.filter(obj => obj.name));
                    // Суммируем уже готовые значения с сервера для общего итога
                    setFixations(data.reduce((sum, item) => sum + (item.totalFixations || 0), 0));
                    setViolations(data.reduce((sum, item) => sum + (item.totalViolations || 0), 0));
                }
            }).catch(err => console.log(err));
        }
    }, [interval]);

    useEffect(() => {
        setInterval([dayjs().startOf('day'), dayjs()]);
    }, []);

    // Таблица перекрёстков
    const renderCrossroadTable = () => {
        const data = statisic.filter(host => host.type === 'crossroad');
        // Суммируем уже готовые значения с сервера для итоговой строки
        const totals = {
            fixations: data.reduce((sum, host) => sum + (host.totalFixations || 0), 0),
            violations: data.reduce((sum, host) => sum + (host.totalViolations || 0), 0),
            wrongDir: data.reduce((sum, host) => sum + (host.totalViolationsWrongDir || 0), 0),
            stopLine: data.reduce((sum, host) => sum + (host.totalViolationsStopLine || 0), 0),
            redLight: data.reduce((sum, host) => sum + (host.totalViolationsRedLight || 0), 0),
            leftTurn: data.reduce((sum, host) => sum + (host.totalViolationsLeftTurn || 0), 0)
        };

        return (
            <StyledTableContainer component={Paper} elevation={0}>
                <Table size="small" stickyHeader>
                    <StyledTableHead>
                        <TableRow>
                            <TableCell rowSpan={2} align="center" sx={{ verticalAlign: 'middle' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5, flexWrap: 'wrap' }}>
                                    <Traffic sx={{ fontSize: { xs: 12, md: 14 } }} /> <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>Комплекс</Box>
                                </Box>
                            </TableCell>
                            <TableCell rowSpan={2} align="center" sx={{ verticalAlign: 'middle' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5, flexWrap: 'wrap' }}>
                                    <DirectionsCar sx={{ fontSize: { xs: 12, md: 14 } }} /> <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>Проездов</Box>
                                </Box>
                            </TableCell>
                            <TableCell colSpan={5} align="center">
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5, flexWrap: 'wrap' }}>
                                    <Warning sx={{ fontSize: { xs: 12, md: 14 } }} /> <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>Нарушений</Box>
                                </Box>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="center">Всего</TableCell>
                            <TableCell align="center">
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5, flexWrap: 'wrap' }}>
                                    <Traffic sx={{ fontSize: { xs: 10, md: 12 } }} /> <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>Красный</Box>
                                </Box>
                            </TableCell>
                            <TableCell align="center">
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5, flexWrap: 'wrap' }}>
                                    <StopCircle sx={{ fontSize: { xs: 10, md: 12 } }} /> <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>Стоп-линия</Box>
                                </Box>
                            </TableCell>
                            <TableCell align="center"><Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>Встречка</Box></TableCell>
                            <TableCell align="center">
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5, flexWrap: 'wrap' }}>
                                    <TurnLeft sx={{ fontSize: { xs: 10, md: 12 } }} /> <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>Поворот</Box>
                                </Box>
                            </TableCell>
                        </TableRow>
                    </StyledTableHead>
                    <TableBody>
                        {data.map(host => (
                            <StyledTableRow key={host.name}>
                                <StyledTableCell sx={{ fontWeight: 500 }}>{host.name}</StyledTableCell>
                                <StyledTableCell align="center">
                                    <Chip label={host.totalFixations} size="small" sx={{ 
                                        height: { xs: 18, md: 20 }, fontSize: { xs: '9px', md: '10px' }, fontWeight: 600,
                                        backgroundColor: alpha(primaryColor, 0.12), color: primaryColor 
                                    }} />
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                    <Chip label={host.totalViolations} size="small" sx={{ 
                                        height: { xs: 18, md: 20 }, fontSize: { xs: '9px', md: '10px' }, fontWeight: 600,
                                        backgroundColor: alpha(errorColor, 0.12), color: errorColor 
                                    }} />
                                </StyledTableCell>
                                <StyledTableCell align="center">{host.totalViolationsRedLight}</StyledTableCell>
                                <StyledTableCell align="center">{host.totalViolationsStopLine}</StyledTableCell>
                                <StyledTableCell align="center">{host.totalViolationsWrongDir}</StyledTableCell>
                                <StyledTableCell align="center">{host.totalViolationsLeftTurn}</StyledTableCell>
                            </StyledTableRow>
                        ))}
                        <TotalTableRow>
                            <StyledTableCell sx={{ fontWeight: 600 }}>Всего</StyledTableCell>
                            <StyledTableCell align="center">
                                <Chip label={totals.fixations} size="small" sx={{ 
                                    height: { xs: 20, md: 22 }, fontSize: { xs: '9px', md: '10px' }, fontWeight: 700,
                                    backgroundColor: primaryColor, color: 'white' 
                                }} />
                            </StyledTableCell>
                            <StyledTableCell align="center">
                                <Chip label={totals.violations} size="small" sx={{ 
                                    height: { xs: 20, md: 22 }, fontSize: { xs: '9px', md: '10px' }, fontWeight: 700,
                                    backgroundColor: errorColor, color: 'white' 
                                }} />
                            </StyledTableCell>
                            <StyledTableCell align="center" sx={{ fontWeight: 600 }}>{totals.redLight}</StyledTableCell>
                            <StyledTableCell align="center" sx={{ fontWeight: 600 }}>{totals.stopLine}</StyledTableCell>
                            <StyledTableCell align="center" sx={{ fontWeight: 600 }}>{totals.wrongDir}</StyledTableCell>
                            <StyledTableCell align="center" sx={{ fontWeight: 600 }}>{totals.leftTurn}</StyledTableCell>
                        </TotalTableRow>
                    </TableBody>
                </Table>
            </StyledTableContainer>
        );
    };

    // Простая таблица (для скоростных и парковки)
    const renderSimpleTable = (type, icon) => {
        const data = statisic.filter(host => host.type === type);
        const totals = {
            fixations: data.reduce((a, b) => a + b.totalFixations, 0),
            violations: data.reduce((a, b) => a + b.totalViolations, 0)
        };

        return (
            <StyledTableContainer component={Paper} elevation={0}>
                <Table size="small" stickyHeader>
                    <StyledTableHead>
                        <TableRow>
                            <TableCell align="center">
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5, flexWrap: 'wrap' }}>
                                    {icon} <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>Комплекс</Box>
                                </Box>
                            </TableCell>
                            <TableCell align="center">
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5, flexWrap: 'wrap' }}>
                                    <DirectionsCar sx={{ fontSize: { xs: 12, md: 14 } }} /> <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>Проездов</Box>
                                </Box>
                            </TableCell>
                            <TableCell align="center">
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5, flexWrap: 'wrap' }}>
                                    <Warning sx={{ fontSize: { xs: 12, md: 14 } }} /> <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>Нарушений</Box>
                                </Box>
                            </TableCell>
                        </TableRow>
                    </StyledTableHead>
                    <TableBody>
                        {data.map(host => (
                            <StyledTableRow key={host.name}>
                                <StyledTableCell sx={{ fontWeight: 500 }}>{host.name}</StyledTableCell>
                                <StyledTableCell align="center">
                                    <Chip label={host.totalFixations} size="small" sx={{ 
                                        height: { xs: 18, md: 20 }, fontSize: { xs: '9px', md: '10px' }, fontWeight: 600,
                                        backgroundColor: alpha(primaryColor, 0.12), color: primaryColor 
                                    }} />
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                    <Chip label={host.totalViolations} size="small" sx={{ 
                                        height: { xs: 18, md: 20 }, fontSize: { xs: '9px', md: '10px' }, fontWeight: 600,
                                        backgroundColor: alpha(errorColor, 0.12), color: errorColor 
                                    }} />
                                </StyledTableCell>
                            </StyledTableRow>
                        ))}
                        <TotalTableRow>
                            <StyledTableCell sx={{ fontWeight: 600 }}>Всего</StyledTableCell>
                            <StyledTableCell align="center">
                                <Chip label={totals.fixations} size="small" sx={{ 
                                    height: { xs: 20, md: 22 }, fontSize: { xs: '9px', md: '10px' }, fontWeight: 700,
                                    backgroundColor: primaryColor, color: 'white' 
                                }} />
                            </StyledTableCell>
                            <StyledTableCell align="center">
                                <Chip label={totals.violations} size="small" sx={{ 
                                    height: { xs: 20, md: 22 }, fontSize: { xs: '9px', md: '10px' }, fontWeight: 700,
                                    backgroundColor: errorColor, color: 'white' 
                                }} />
                            </StyledTableCell>
                        </TotalTableRow>
                    </TableBody>
                </Table>
            </StyledTableContainer>
        );
    };

    return (
        <Dialog 
            open={true}
            maxWidth="lg"
            fullWidth
            fullScreen={isMobile}
            onClose={() => map.fire('modalclose')}
            scroll="paper"
            PaperProps={{
                sx: {
                    backgroundColor: 'var(--background-default)',
                    color: 'var(--text-primary)',
                    backgroundImage: 'none',
                    borderRadius: { xs: 0, md: '12px' },
                    border: { xs: 'none', md: '1px solid var(--border-default)' },
                    boxShadow: { xs: 'none', md: 'var(--shadow-lg)' },
                    margin: { xs: 0, md: '32px' },
                    maxHeight: { xs: '100%', md: 'calc(100% - 64px)' },
                    height: { xs: '100%', md: 'auto' }
                }
            }}
        >
            <DialogTitle sx={{ 
                p: { xs: '4px 12px', md: '10px 16px' }, 
                backgroundColor: 'var(--background-default)',
                borderBottom: '1px solid var(--border-default)',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexWrap: { xs: 'wrap', md: 'nowrap' },
                gap: { xs: 1, md: 0 }
            }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, md: 1.5 } }}>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: { xs: 24, md: 28 },
                        height: { xs: 24, md: 28 },
                        borderRadius: { xs: '4px', md: '6px' },
                        backgroundColor: primaryColor,
                        color: 'white'
                    }}>
                        <Warning sx={{ fontSize: { xs: 14, md: 16 } }} />
                    </Box>
                    <Typography sx={{ fontSize: { xs: '0.85rem', md: '0.95rem' }, fontWeight: 600, color: 'var(--text-primary)' }}>
                        Статистика нарушений
                    </Typography>
                </Box>
                
                <IconButton 
                    size="small" 
                    onClick={() => map.fire('modalclose')}
                    sx={{ 
                        color: 'var(--text-secondary)', 
                        ml: { xs: 0, md: 1 },
                        padding: { xs: '4px', md: '8px' }
                    }}
                >
                    <Close sx={{ fontSize: { xs: 18, md: 20 } }} />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ p: { xs: 0.5, md: 2 }, backgroundColor: 'var(--background-default)' }}>
                {/* Выбор периода */}
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ru">
                    <Box sx={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: { xs: 0.75, md: 1 }, 
                        flexWrap: 'wrap', 
                        width: '100%',
                        mb: { xs: 0.5, md: 2 },
                        p: { xs: 1, md: 1.5 },
                        backgroundColor: 'var(--background-paper)',
                        borderRadius: { xs: '6px', md: '8px' },
                        border: '1px solid var(--border-default)'
                    }}>
                        <DatePicker
                            value={interval[0]}
                            onChange={(v) => setInterval([v, interval[1]])}
                            slotProps={{
                                textField: { 
                                    size: 'small', 
                                    sx: { 
                                        ...datePickerSx, 
                                        width: { xs: '100%', md: 140 }
                                    } 
                                },
                                popper: {
                                    sx: datePickerPopperSx,
                                    placement: { xs: 'bottom-start', md: 'bottom' }
                                },
                                actionBar: {
                                    actions: ['clear', 'cancel', 'accept'],
                                    sx: {
                                        '& .MuiButton-root': {
                                            fontSize: { xs: '0.75rem', md: '0.875rem' },
                                            padding: { xs: '4px 8px', md: '6px 12px' },
                                            color: 'var(--text-primary)',
                                            '&.MuiButton-textPrimary': {
                                                color: primaryColor
                                            }
                                        }
                                    }
                                }
                            }}
                        />
                        <Typography sx={{ color: 'var(--text-muted)', fontSize: { xs: '10px', md: '11px' }, display: { xs: 'none', md: 'block' } }}>—</Typography>
                        <DatePicker
                            value={interval[1]}
                            onChange={(v) => setInterval([interval[0], v])}
                            slotProps={{
                                textField: { 
                                    size: 'small', 
                                    sx: { 
                                        ...datePickerSx, 
                                        width: { xs: '100%', md: 140 }
                                    } 
                                },
                                popper: {
                                    sx: datePickerPopperSx,
                                    placement: { xs: 'bottom-start', md: 'bottom' }
                                },
                                actionBar: {
                                    actions: ['clear', 'cancel', 'accept'],
                                    sx: {
                                        '& .MuiButton-root': {
                                            fontSize: { xs: '0.75rem', md: '0.875rem' },
                                            padding: { xs: '4px 8px', md: '6px 12px' },
                                            color: 'var(--text-primary)',
                                            '&.MuiButton-textPrimary': {
                                                color: primaryColor
                                            }
                                        }
                                    }
                                }
                            }}
                        />
                        
                        <Box sx={{ display: 'flex', gap: { xs: 0.4, md: 0.5 }, width: { xs: '100%', md: 'auto' }, flexWrap: 'wrap' }}>
                            <Button size="small" variant="outlined" sx={{ ...quickButtonSx, fontSize: { xs: '10px', md: '11px' }, padding: { xs: '3px 8px', md: '4px 10px' } }}
                                startIcon={<Today sx={{ fontSize: { xs: 12, md: 14 } }} />}
                                onClick={() => setInterval([dayjs().startOf('day'), dayjs().endOf('day')])}>
                            Сегодня
                        </Button>
                            <Button size="small" variant="outlined" sx={{ ...quickButtonSx, fontSize: { xs: '10px', md: '11px' }, padding: { xs: '3px 8px', md: '4px 10px' } }}
                                startIcon={<DateRange sx={{ fontSize: { xs: 12, md: 14 } }} />}
                            onClick={() => {
                                    const tmp = dayjs().subtract(1, 'day');
                                    setInterval([tmp.startOf('day'), tmp.endOf('day')]);
                                }}>
                            Вчера
                        </Button>
                            <Button size="small" variant="outlined" sx={{ ...quickButtonSx, fontSize: { xs: '10px', md: '11px' }, padding: { xs: '3px 8px', md: '4px 10px' } }}
                                onClick={() => setInterval([dayjs().subtract(7, 'day').startOf('day'), dayjs().endOf('day')])}>
                                7 дн.
                        </Button>
                            <Button size="small" variant="outlined" sx={{ ...quickButtonSx, fontSize: { xs: '10px', md: '11px' }, padding: { xs: '3px 8px', md: '4px 10px' } }}
                                onClick={() => setInterval([dayjs().subtract(30, 'day').startOf('day'), dayjs().endOf('day')])}>
                                30 дн.
                        </Button>
                        </Box>
                    </Box>
                </LocalizationProvider>
                
                <Box sx={{ borderBottom: 1, borderColor: 'var(--border-default)', mb: { xs: 0.75, md: 1 } }}>
                    <Tabs 
                        value={tabValue} 
                        onChange={handleTabChange}
                        variant="scrollable"
                        scrollButtons="auto"
                        sx={{
                            minHeight: { xs: 32, md: 36 },
                            '& .MuiTab-root': {
                                minHeight: { xs: 32, md: 36 },
                                textTransform: 'none',
                                fontSize: { xs: '11px', md: '12px' },
                                fontWeight: 500,
                                padding: { xs: '4px 8px', md: '6px 12px' },
                                color: 'var(--text-secondary)',
                                '&.Mui-selected': { color: primaryColor }
                            },
                            '& .MuiTabs-indicator': { backgroundColor: primaryColor },
                            '& .MuiTabs-scrollButtons': {
                                width: { xs: 28, md: 40 },
                                '& .MuiSvgIcon-root': { fontSize: { xs: 16, md: 20 } }
                            }
                        }}
                    >
                        <Tab icon={<Traffic sx={{ fontSize: { xs: 14, md: 16 } }} />} iconPosition="start" label="Перекрестки" />
                        <Tab icon={<Speed sx={{ fontSize: { xs: 14, md: 16 } }} />} iconPosition="start" label="Скоростные" />
                        <Tab icon={<LocalParking sx={{ fontSize: { xs: 14, md: 16 } }} />} iconPosition="start" label="Парковка" />
                        </Tabs>
                    </Box>
                    
                    <TabPanel value={tabValue} index={0}>
                    {renderCrossroadTable()}
                    </TabPanel>
                    <TabPanel value={tabValue} index={1}>
                    {renderSimpleTable('speed', <Speed sx={{ fontSize: { xs: 12, md: 14 } }} />)}
                    </TabPanel>
                    <TabPanel value={tabValue} index={2}>
                    {renderSimpleTable('parking', <LocalParking sx={{ fontSize: { xs: 12, md: 14 } }} />)}
                    </TabPanel>
            </DialogContent>

            <DialogActions sx={{ 
                p: { xs: '4px 6px', md: '10px 16px' }, 
                backgroundColor: 'var(--background-default)',
                borderTop: '1px solid var(--border-default)',
                justifyContent: 'space-between',
                flexDirection: { xs: 'row', md: 'row' },
                gap: { xs: 1, md: 0 }
            }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 0.5, md: 1.5 }, flexWrap: 'wrap', width: { xs: '100%', md: 'auto' } }}>
                    <Typography sx={{ fontSize: { xs: '10px', md: '11px' }, fontWeight: 600, color: 'var(--text-secondary)' }}>
                        Всего:
                    </Typography>
                    <Chip 
                        icon={<DirectionsCar sx={{ fontSize: { xs: 10, md: 12 } }} />}
                        label={fixations.toLocaleString('ru-RU')} 
                        size="small"
                        sx={{ 
                            height: { xs: 20, md: 22 }, fontSize: { xs: '9px', md: '10px' }, fontWeight: 600,
                            backgroundColor: alpha(successColor, 0.15), color: successColor,
                            '& .MuiChip-icon': { color: successColor }
                        }}
                    />
                    <Chip 
                        icon={<Warning sx={{ fontSize: { xs: 10, md: 12 } }} />}
                        label={violations.toLocaleString('ru-RU')} 
                        size="small"
                        sx={{ 
                            height: { xs: 20, md: 22 }, fontSize: { xs: '9px', md: '10px' }, fontWeight: 600,
                            backgroundColor: alpha(errorColor, 0.15), color: errorColor,
                            '& .MuiChip-icon': { color: errorColor }
                        }}
                    />
                </Box>
                <Box sx={{ display: 'flex', gap: { xs: 0.75, md: 1 }, width: { xs: '100%', md: 'auto' } }}>
                    <Button 
                        size="small" 
                        variant="outlined" 
                        startIcon={<Download sx={{ fontSize: { xs: 12, md: 14 } }} />}
                        onClick={toExcel}
                        fullWidth={false}
                        sx={{
                            borderColor: 'var(--border-default)',
                            color: 'var(--text-primary)',
                            borderRadius: { xs: '4px', md: '6px' },
                            textTransform: 'none',
                            fontSize: { xs: '10px', md: '11px' },
                            padding: { xs: '2px 6px', md: '4px 10px' },
                            width: { xs: '100%', md: 'auto' },
                            '&:hover': {
                                borderColor: primaryColor,
                                backgroundColor: alpha(primaryColor, 0.08)
                            }
                        }}
                    >
                        Выгрузить
                    </Button>
                    <Button 
                        size="small" 
                        variant="contained" 
                        onClick={() => map.fire('modalclose')}
                        fullWidth={false}
                        sx={{
                            backgroundColor: primaryColor,
                            borderRadius: { xs: '4px', md: '6px' },
                            textTransform: 'none',
                            fontSize: { xs: '10px', md: '11px' },
                            padding: { xs: '2px 6px', md: '4px 10px' },
                            width: { xs: '100%', md: 'auto' },
                            '&:hover': { backgroundColor: alpha(primaryColor, 0.9) }
                        }}
                    >
                        Закрыть
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
};

export default ModalStat;
